import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/es5/util/colors';
import '@mdi/font/css/materialdesignicons.css';
// import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify);

export default new Vuetify({
  options: {
    customProperties: true,
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: {
          base: colors.orange.base,
        },
      },
    },
  },
});
